<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Création d'un ticket </CCardHeader>

					<CCardBody>
						<CContainer fluid class="container">
							<div class="loader" v-show="isLoading">
								<CSpinner color="info" />
							</div>
							<transition name="fade">
								<CContainer fluid v-show="!isLoading">
									<form
										ref="form"
										method="POST"
										axiosMethod="post"
										action="/api/support_tickets">
										<SelectCustomerCard
											:disabled="isEdit"
											input-name="customer"
											:customer="customer"
											v-on:update:selection="customerId = $event" />
										<SelectPackageCard v-if="customer" :customer="customer" />
										<TicketInfoCard v-if="customer" />
										<CButton
											v-if="customer"
											class="float-right"
											@click="onSubmit($refs.form)"
											color="success">
											Créer le ticket
										</CButton>
									</form>
								</CContainer>
							</transition>
						</CContainer>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import SelectCustomerCard from '../../../../components/cards/select-customer-card';
	import SelectPackageCard from './_components/SelectPackageCard';
	import CreateOrder from '../orders/create-order';
	import TicketInfoCard from './_components/TicketInfoCard';

	export default {
		components: { TicketInfoCard, CreateOrder, SelectPackageCard, SelectCustomerCard },
		props: {
			isEdit: {
				type: Boolean,
				default: false,
			},
			customerId: {
				type: String,
				default: null,
			},
		},
		watch: {
			customerId: {
				immediate: true,
				handler: function () {
					if (this.customerId != null) {
						this.isLoading = true;

						this.$axios
							.get(this.customerId)
							.then(res => {
								this.customer = res.data;
								this.isLoading = false;
							})
							.catch(this.error);
					}
				},
			},
		},

		data() {
			return {
				isLoading: false,
				customer: null,
				message: null,
			};
		},
		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Nouveau ticket créé avec succès !');
						this.$router.push(`/orders/customer-service/tickets/${res.data.id}/edit`);
					}
				});
			},
		},
	};
</script>

<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.container {
		min-height: 67vh;
		position: relative;
		display: flex;
	}

	.card-container {
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: center;
	}

	.loader {
		position: absolute;
		left: 50%;
		top: 50%;
	}
</style>
